export default __webpack_public_path__ + "static/media/arrow_left.1052c548.svg";